import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { ActionFunctionArgs, redirect, useLoaderData, useNavigate, useSubmit } from 'react-router-dom';
import styled from 'styled-components';
import { assignAsset, fetchAssetById, fetchLearners } from '../api';
import { Field, Formik, Form as FormikForm } from 'formik';
import { object, string } from 'yup';
import { useMemo } from 'react';
import { get } from 'lodash';


const StyledOption = styled.option``;
const StyledButton = styled(Button)`
  background-color: #3498db;
  border-color: #3498db;
  color: #fff;
`;

export async function assignAssetAction({ request }: ActionFunctionArgs) {
  const { values, asset } = await request.json();
  await assignAsset(asset.id, values);

  return redirect(`/assets`);
}

export async function assignAssetLoader({ params }: any) {
  const asset = await fetchAssetById(get(params, 'assetId'));
  const learners = await fetchLearners();
  return { asset, learners };
}

const initialValues = {
  assigned_to: ''
};

const validationSchema = object({
  assigned_to: string().required('Learner is required'),
});

function AssignAsset() {
  const { asset, learners } = useLoaderData() as any;
  const navigate = useNavigate();
  const submit = useSubmit();

  const handleClose: any = () => navigate(-1);

  const handleSubmit = (values: any) => {
    submit({ values, asset }, { method: "patch", encType: 'application/json' });
  };

  const mappedLearnerOptions = useMemo(() => {
    return learners.map((learner: any, index: number) => {
      const option = ({ value: get(learner, 'person.id'), label: learner.name });
      return (<StyledOption key={index} value={option.value}>{option.label}</StyledOption>);
    });
  }, [learners]);

  return (
    <Modal
      show={true}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ touched, errors }) => (
          <Form as={FormikForm} noValidate>
            <Modal.Header closeButton>
              <Modal.Title>Assign Asset</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group as={Row} className="mb-3" controlId="assigned_to">
                <Form.Label column sm="4">
                  Learner:
                </Form.Label>
                <Col sm="8">
                  <Field
                    as={Form.Select}
                    name='assigned_to'
                    isInvalid={touched.assigned_to && !!errors.assigned_to}
                  >
                    <StyledOption></StyledOption>
                    {mappedLearnerOptions}
                  </Field>
                  <Form.Control.Feedback type='invalid'>{errors.assigned_to as any}</Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="light" onClick={handleClose}>
                Close
              </Button>
              <StyledButton type='submit'>Submit</StyledButton>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default AssignAsset;
